<template>
    <div class="stage">
        <div class="patient-wrapper">
            <div class="patient-block">
                <div class="patient-title">
                    Дайте пацієнту ім’я,
                </div>

                <div class="patient-subtitle">
                    щоб Ви могли потім впізнати його серед інших пацієнтів  
                </div>

                <div class="patient-name">
                    <div class="title">
                        Ім’я Вашого пацієнта кирилицею або латиницею
                    </div>
                    <div class="value">
                        <!-- <button class="ok-button" :class="$store.state.patient.stageError ? 'error-button' : ''">Ок</button> -->
                        <input class="name" @focus="focusFunction()" @blur="blurFunction()" @input="removeStageError()" :class="$store.state.patient.stageError ? 'error-input' : ''" type="text" id="name" placeholder="Введіть ім’я пацієнта" v-model="name" required>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../components/Doctor/ErrorBlock';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        name : ''
    }),
    created(){
        this.name = this.$store.state.patient.mainInfo.name;
    },
    methods : {
        removeStageError(){
            this.$store.commit('removeStageError');
        },
        focusFunction(){
            let userAgent = navigator.userAgent.toLowerCase(); 
            let Android = userAgent.indexOf("android") > -1;


            if(Android){
                let progressBar = document.getElementById('progress-bar');
                progressBar.style.display = "none";
            }
        },
        blurFunction(){
            let userAgent = navigator.userAgent.toLowerCase(); 
            let Android = userAgent.indexOf("android") > -1;

            if(Android){
                let progressBar = document.getElementById('progress-bar');
                progressBar.style.display = "block";
            }
        }
    },
    watch : {
        name : function(value){
            this.$store.commit('setPatientName', value);
        }
    }
}
</script>

<style lang="scss">
.stage{
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .patient-wrapper{
        background: #F1F4F5;
        border-radius: 20px;

        width: 405px;
        height: 267px;

        .patient-block{
            padding: 35px 40px;

            color: #575A5D;

            text-align: left;
            font-style: normal;

            .patient-title{
                font-weight: bold;
                font-size: 26px;

                padding-bottom: 4px;
            }

            .patient-subtitle{
                font-size: 20px;
                font-weight: bold;

                padding-bottom: 18px;
            }

            .patient-name{
                padding-bottom: 16px;

                .title{
                    font-style: normal;
                    font-weight: 500;
                    font-size: 12px;

                    padding-bottom: 18px;
                }

                .value{
                    width: 100%;

                    position: relative;

                    .ok-button{
                        position: absolute;
                        right: 1px;
                        top: 1px;
                        bottom: 1px;

                        width: 65px;
                        height: 37px;

                        outline: none;
                        border: none;
                        border-radius: 100px;

                        background: rgba(87, 90, 93, 0.3);
                        color: #ffffff;

                        font-style: normal;
                        font-weight: bold;
                        font-size: 14px;
                        line-height: 20px;
                    }

                    .name{
                        width: calc(100% - 24px);
                        // width: 100%;
                        padding: 12px 12px;
                        margin: 0;
                        border: 0;
                        outline: 0;

                        background: #FFFFFF;
                        box-shadow: 4px 4px 20px rgba(37, 93, 111, 0.1);
                        border-radius: 50px;

                        font-weight: bold;
                        color: #575A5D;
                        // font-family: 'HelveticaNeueCyr';
                    }

                    .name::placeholder{
                        color: rgba(87, 90, 93, 0.5);
                    }

                    .error-input{
                        &.name{
                            width: 100%;
                        }

                        border: 1px solid rgba(179, 0, 55, 0.5);
                        box-sizing: border-box;
                        box-shadow: 4px 4px 20px rgba(37, 93, 111, 0.1);
                    }

                    .error-button{
                        right: 2px;
                        top: 2px;
                    }
                }
            }         
        }        
    }

    .error-block{
        padding-left: 0;
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .patient-wrapper{
            width: 40vw;
            height: auto;

            .patient-block{
                padding: 3.125vw 3.333vw;

                .patient-title{
                    font-size: 2.500vw;

                    padding-bottom: 0.417vw;
                }

                .patient-subtitle{
                    font-size: 1.875vw;

                    padding-bottom: 1.667vw;
                }

                .patient-name{
                    padding-bottom: 0.833vw;

                    .title{
                        font-size: 1.250vw;

                        padding-bottom: 2.292vw;
                    }

                    .value{

                        .name{
                            width: calc(100% - 1.458vw - 1.458vw);

                            padding: 0.833vw 1.458vw;
                            font-size: 1.042vw;
                            // font-family: 'HelveticaNeueLTStd';
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 599px){
    .stage{
        align-items: flex-start;

        .patient-wrapper{
            width: 100%;
            height: auto;

            .patient-block{
                padding: 5.556vw 5.556vw 6.667vw;

                .patient-title{
                    font-size: 5.556vw;
                    padding-bottom: 2.222vw;
                }

                .patient-subtitle{
                    font-size: 4.444vw;
                    padding-bottom: 4.444vw;
                }

                .patient-name{
                    padding-bottom: 0;

                    .title{
                        font-size: 3.889vw;

                        padding-bottom: 4.444vw;
                    }

                    .value{
                        .name{
                            width: calc(100% - 5.556vw - 5.556vw);
                            padding: 2.778vw 5.556vw;
                        }
                    }
                } 
            }
        }
    }
}
</style>